import { Controller } from "stimulus";
import RequestQueue from 'classes/RequestQueue';
import _ from 'lodash';

class StaticSponsorRowController extends Controller {
  static targets = [
    'symbol',
    'legalName',
    'securityType',
    'lastPrice',
    'priceChangePercentage',
    'netAssets',
    'ltmYield',
    'ltmDividend',
    'expenseRatio',
    'watchlistState'
  ]

  connect() {
    this.ticker = this._processedDataFromSource();
    this.isSearchCenter = (this.element.getAttribute('data-is-search') || false);

    this.updateSRData();
  }

  updateSRData = () => {
    this.replaceTargetWithValue('symbol', ticker => _.isEmpty(ticker.symbol) ? '-' : ticker.symbol);
    this.replaceTargetWithValue('legalName', ticker => _.isEmpty(this.legalName) ? '-' : this.legalName.replace('®', '\<sup\>®\</sup\>'));
    this.replaceTargetWithValue('securityType', ticker => this.__normalizedSecurityType(ticker.security_type, ticker.index_fund));
    this.replaceTargetWithValue('lastPrice', ticker => (_.isNil(ticker.last_price) ? '-' : '$' + ticker.last_price));
    this.replaceTargetWithValue('priceChangePercentage', ticker => _.isNil(ticker.price_change_percent) ? '-' : new Intl.NumberFormat('en-US', { signDisplay: 'always', style: 'percent', minimumFractionDigits: 2 }).format(ticker.price_change_percent / 100));
    this.replaceTargetWithValue('netAssets', ticker => !this.netAssets ? '-' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting', notation: "compact" }).format(this.netAssets));
    this.replaceTargetWithValue('ltmYield', ticker => _.isNil(ticker.dividend_yield_current) ? '-' : new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2 }).format(ticker.dividend_yield_current));
    this.replaceTargetWithValue('ltmDividend', ticker => _.isNil(ticker.dividend_annual_current) ? '-' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting' }).format(ticker.dividend_annual_current));
    this.replaceTargetWithValue('expenseRatio', ticker => _.isEmpty(ticker.expense_ratio) ? '-' : new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2 }).format(ticker.expense_ratio / 100));

    this.replaceTargetWithValue('watchlistState', null, (target, ticker) => (this.isSearchCenter ? target.setAttribute('data-watchlist-state', ticker.watchlist_state) : this.__fetchWatchlistButton(ticker, target)));
  }

  __normalizedSecurityType = (securityType, indexFund) => {
    if (securityType) {
      const lowercasedST = securityType.toLowerCase();
      if (lowercasedST === 'etf') {
        if (indexFund === false) {
          return 'Active ETF'
        } else {
          return 'ETF';
        }
      } else if (lowercasedST === 'mutual_fund') {
        return 'Fund';
      } else if (lowercasedST === 'stock') {
        return 'Stock';
      } else {
        return 'Fund';
      }
    } else {
      return 'Fund'
    }
  }

  replaceTargetWithValue = (targetName, replaceFunction, targetFunction) => {
    const hasTargetString = _.camelCase(`has ${targetName} target`);
    const targetsString = _.camelCase(`${targetName} targets`);
    if (this[hasTargetString]) {
      this[targetsString].forEach(target => {
        if (this.ticker && replaceFunction) {
          target.innerHTML = replaceFunction(this.ticker);
        } else {
          if(targetName != "watchlistState") {
            target.innerHTML = '-';
          }
        }

        if (this.ticker && targetFunction) {
          targetFunction(target, this.ticker);
        }
      })
    }
  }

  _processedDataFromSource = () => {
    const symbol = this.data.get('symbol');
    const { cachedSecurities } = window.MConstants;

    const [ticker] = cachedSecurities.map(security => security.data).filter(security => {
      return symbol === security.symbol
    });

    return ticker;
  }

  showDisclaimer() {
    EventManager.emit('sponsor-row-show-disclaimer', {
      disclaimerText: this.element.dataset.disclaimerText
    });
  }

  mouseEnterDisclaimer() {
    this.disclaimerTimeout = setTimeout(() => {
      this.showDisclaimer();
    }, 500);
  }

  mouseLeaveDisclaimer() {
    clearTimeout(this.disclaimerTimeout);
  }

  async __fetchWatchlistButton(ticker_data, target) {
    const { data } = await RequestQueue.addToQueue({
      method: 'post',
      url: "/api/components/watchlist-ticker-button/",
      data: {
        ticker_data,
        main_class: "n-ticker-watchlist-btn-blue"
      }
    })

    this.appendWatchlistButton(data, target);
  }

  async appendWatchlistButton(data, target) {
    const parser = new DOMParser();
    const fragment = parser.parseFromString(data, 'text/html').body;
    const firstChild = fragment.firstElementChild || document.createElement('div');
    target.append(firstChild);
  }
  
  get legalName() {
    return this.ticker.legal_name || this.ticker.name
  }

  get netAssets() {
    return this.ticker.net_assets || this.ticker.market_cap
  }
}

export default StaticSponsorRowController;
